import { FC } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import { EyeOutlined } from '@ant-design/icons';
import { GetReportById } from 'gql/reports/__generated__/GetReportById';
import { GET_REPORT_BY_ID } from 'gql/reports/queries';
import { useUIDispatchContext } from 'providers/UI';
import dayjs from 'dayjs';

interface IProps {
  id: string;
}

const ViewReport: FC<IProps> = ({ id }) => {
  const { t } = useTranslation();
  const { toggleModal } = useUIDispatchContext();

  const [getReportById, { loading }] = useLazyQuery<GetReportById>(
    GET_REPORT_BY_ID,
    {
      variables: {
        id
      },
      onCompleted(data) {
        const res = data.getReportById?.data;

        if (res) {
          toggleModal('reportPreview', true, {
            date: res.date_report ? dayjs(res.date_report).format() : '',
            aboutDoctor: res.doctor_info || '',
            report: res.report || '',
            patientBirth: res.date_of_birth
              ? dayjs(res.date_of_birth).format()
              : '',
            patientName: res.first_name || '',
            patientLastName: res.last_name || '',
            appointmentId: res.appointment_id || '',
            signature: res.signature || '',
            lang: res.lang,
            icd: res.icd
          });
        }
      }
    }
  );

  const onClickViewReport = () => {
    getReportById({
      variables: {
        id
      }
    });
  };

  return (
    <Button
      style={{ minWidth: 135 }}
      loading={loading}
      onClick={onClickViewReport}
      icon={<EyeOutlined />}
    >
      {t('reports.view_report')}
    </Button>
  );
};

export default ViewReport;
